import { xyEquallySpaced } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function equallySpaced(data, options = {}) {
    return { data: xyEquallySpaced(data, options) };
}
//# sourceMappingURL=equallySpaced.js.map